import React from 'react';
import { ModalBody } from 'reactstrap';

import createModalToggle from '../../generic/create-modal-toggle';
import ListAttachments from '../ListAttachments';

const AttachmentsModal = createModalToggle(
  'Attachments',
  props => (
    <ModalBody>
      <ListAttachments {...props} />
    </ModalBody>
  ),
  {},
  { size: 'xl' },
);

export default AttachmentsModal;
